import { defineMessages } from '@jutro/locale';

export default defineMessages({
    anErrorOccurred: {
        id: 'quoteandbind.ho.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.ho.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    home: {
        id: 'quoteandbind.wizard.step.Home',
        defaultMessage: 'Home'
    },
    saveQuoteError: {
        id: 'quoteandbind.ho.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.ho.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    customerDetails: {
        id: 'ml.quoteandbind.ho.wizard.step.Customer Details',
        defaultMessage: 'Customer Details'
    },
    underwritingInfo: {
        id: 'ml.quoteandbind.ho.wizard.step.Underwriting Info',
        defaultMessage: 'Underwriting Info'
    },
    generalInfo: {
        id: 'ml.quoteandbind.ho.wizard.General Info',
        defaultMessage: 'General Info'
    },
    propertyDetails: {
        id: 'ml.quoteandbind.ho.wizard.Property Details',
        defaultMessage: 'Property Details'
    },
    purchase: {
        id: 'ml.quoteandbind.ho.wizard.Purchase',
        defaultMessage: 'Purchase'
    },
    validateInfo: {
        id: 'ml.quoteandbind.ho.wizard.step.Validate Information',
        defaultMessage: 'Validate Information'
    },
    homeDetails: {
        id: 'ml.quoteandbind.ho.wizard.step.Home Details',
        defaultMessage: 'Home Details'
    },
});
